import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

import { SelectItem, LazyLoadEvent, Table } from 'primeng';
import { ImportDataType } from '../../interfaces/data-import/import-data-type';
import { IPageResult } from '../../interfaces/page-result';
import { ITrucks } from '../../interfaces/trucks';
import { ITrucksFilter } from '../../interfaces/trucks-filter';
import { IUserOrganisationLevel } from '../../interfaces/user-organisation-level';
import { AuthService } from '../../services';
import { BoardingCheckListService } from '../../services';
import { OrganisationsService } from '../../services';
import { SupplierService } from '../../services';
import { TrucksService } from '../../services';

@Component({
  selector: 'page-trucks',
  templateUrl: './manage-trucks.component.html',
})
export class TrucksComponent implements OnInit {
  public backTo: string;
  public isActiveCheckList: boolean = false;

  public page: IPageResult<ITrucks> = {
    items: [],
    total: 0,
  };

  public event: any;
  public filter: Subject<ITrucksFilter>;
  public filterVal: ITrucksFilter;
  public isLoaded: boolean = false;
  public selectedItem: any;

  truckTypes: SelectItem[];

  @Output() selectedRegionChange: EventEmitter<any>;
  public _selectedRegion: any = 0;
  @Input('selectedRegion')
  public set selectedRegion(value: any) {
    this._selectedRegion = value;
    this.changeSearchRegion(value);
    this.selectedRegionChange.emit(value);
  }

  public get selectedRegion(): any {
    return this._selectedRegion;
  }

  @Output() selectedDepChange: EventEmitter<any>;
  public _selectedDep: any = 0;
  @Input('selectedDep')
  public set selectedDep(value: any) {
    this._selectedDep = value;
    if (value) {
      this.filterVal.filters.depotId.value = value;
    }
    this.selectedDepChange.emit(value);
  }

  public get selectedDep(): any {
    return this._selectedDep;
  }

  depots: SelectItem[] = [{ label: 'All', value: 0 }];
  regions: SelectItem[] = [{ label: 'All', value: 0 }];
  selectedDepot: any;
  public uLevel: IUserOrganisationLevel;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private trucksService: TrucksService,
    private supplierService: SupplierService,
    private organisationsService: OrganisationsService,
    private authService: AuthService,
    private boardingCheckListService: BoardingCheckListService,
  ) {
    this.selectedRegionChange = new EventEmitter<any>();
    this.selectedDepChange = new EventEmitter<any>();
  }

  ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];

    this.boardingCheckListService
      .GetBoardingCheckList()
      .then((x) => {
        if (x) {
          this.isActiveCheckList = !x.isHide;
        }
      })
      .catch();

    this.initDefaultFilter();
    //this.getTruckTypes();

    //level settings
    this.organisationsService.getUserOrganisationLevel().then((resp) => {
      this.uLevel = resp;
      this.getRegions();
      this.getDepots(0);
    });
    //

    this.filter = new Subject<ITrucksFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);
  }

  load(filter: ITrucksFilter) {
    this.trucksService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  onRowSelect(event) {
    this.event = event;
  }

  onEdit() {
    if (this.event !== undefined) {
      this.goToDetails(this.event.data.id);
    }
  }

  onRowDblclick(truck) {
    this.goToDetails(truck.id);
  }

  goToDetails(id: number) {
    this.router.navigate(['app/truck/' + id]);
  }

  AddTruck() {
    this.router.navigate(['app/newtruck']);
  }

  getRegions() {
    this.supplierService.getRegions().then((result) => {
      var allRegions = [];
      if (this.uLevel.isAllDepots) {
        allRegions = result;
      } else if (this.uLevel.isCertainDepots) {
        allRegions = result.filter((x) => this.uLevel.regionId.indexOf(x.id) > -1);
      }

      this.regions = [{ label: 'All', value: 0 }];
      if (allRegions != null) {
        allRegions.forEach((item) => {
          this.regions.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  getDepots(regionId: number) {
    var self = this;
    var f = function (result) {
      var allDepots = [];
      if (self.uLevel.isAllDepots) {
        allDepots = result;
      } else if (result && self.uLevel.isCertainDepots) {
        allDepots = result.filter(
          (x) => self.uLevel.depotId.filter((t) => t.id == x.id).length != 0,
        );
      }

      self.depots = [{ label: 'All', value: 0 }];
      if (allDepots != null) {
        allDepots.forEach((item) => {
          self.depots.push({ label: item.name, value: item.id });
        });
      }

      self.selectedDepot = 0;
    };

    if (regionId == 0) f(null);
    else this.supplierService.getDepots(regionId).then(f);
  }

  getTruckTypes() {
    this.trucksService.getTruckTypes().then((result) => {
      this.truckTypes = [{ label: 'All', value: 0 }];
      if (result != null) {
        result.forEach((item) => {
          this.truckTypes.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  changeSearchRegion(regionId: any) {
    this.filterVal.filters.regionId.value = regionId;
    if (regionId == 0) {
      this.depots = [{ label: 'All', value: 0 }];
      return;
    }

    this.getDepots(regionId);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '', // ASC
      sortOrder: 1,
      filters: {
        assetNumber: {},
        depotId: { value: 0 },
        make: {},
        model: {},
        regionId: { value: 0 },
        registration: {},
      },
    };

    if (this.depots && this.depots.length > 0) {
      this.selectedDep = this.depots[0].value;
    } else {
      this.selectedDep = null;
    }

    if (this.regions && this.regions.length > 0) {
      this.selectedRegion = this.regions[0].value;
    } else {
      this.selectedRegion = null;
    }
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);
  }

  goToImportData() {
    this.router.navigate(['app/dataimport/' + ImportDataType.Trucks]);
  }

  close() {
    if (this.backTo) {
      this.router.navigate([this.backTo]);
    } else if (this.isActiveCheckList) {
      this.router.navigate(['app/']);
    }
  }
}
